import {useMutation} from "@tanstack/react-query";
import { createReport } from "../api/public-voissa/reports";

const REPORT_KIND = {
    ALL: "ALL",
    ALBUM: "ALBUM",
    COMMENT: "COMMENT",
    SUB_COMMENT: "SUB_COMMENT",
    MEDIA_PHOTO: "MEDIA_PHOTO",
    MEDIA_VIDEO: "MEDIA_VIDEO",
    STATUS: "STATUS",
    POLL: "POLL",
    // Réponse privée à une story : signalable par l'auteur de la story seulement.
    EPHEMERAL_STORY_REPLY: "EPHEMERAL_STORY_REPLY",
    // Petit mot laissé sur le mur d'un membre : vise son auteur.
    WALL_NOTE: "WALL_NOTE",
    ARTICLE: "ARTICLE",
    TOPIC:"TOPIC",
    TOPIC_COMMENT: "TOPIC_COMMENT",
    USER: "USER",
    STORY: "STORY",
    // Stories éphémères : un kind par type de média (aligné sur le pattern MEDIA_PHOTO / MEDIA_VIDEO).
    // Le backend filtre les ReportReason.kinds[] via ce discriminant.
    EPHEMERAL_STORY_PHOTO: "EPHEMERAL_STORY_PHOTO",
    EPHEMERAL_STORY_VIDEO: "EPHEMERAL_STORY_VIDEO",
    DEFAULT: "DEFAULT"
};

const useReport = ({
         targetId,
         targetKind,
         targetUserId,  // propriétaire de l'entité signalée — utile pour stories (cf. brief API)
         onSuccess = () =>{},
         onMutate = () =>{},
         onError = () =>{}
     }) =>{


    async function handleSuccess (){
        onSuccess();
    }

    function handleError (){
        onError();
    }

    const {
        mutate, isLoading, error, isError
    } = useMutation((data) => createReport(data),{
        onSuccess: handleSuccess,
        onError: handleError
    });

    function handleReport(note, reasonId, screenshotFileId = null) {
        if(!isLoading){
            mutate({
                targetId,
                targetKind,
                // N'envoie targetUserId que s'il est fourni (rétro-compat : les autres types
                // n'ont jamais passé ce champ, le backend les laisse inférer côté server).
                ...(targetUserId ? { targetUserId } : {}),
                note,
                reasonId,
                screenshotFileId
            });
            onMutate();
        }
    }

    return {handleReport, isLoading, error, isError};
}

export default useReport;
export {REPORT_KIND};